import { Helmet } from "react-helmet-async";
import { useSettings } from "@/context/SettingsContext";

export default function BrandingHead() {
  const s = useSettings();
  if (!s) return null;
  const v = s.favicon_version || 1;
  const bust = (u) => (u ? `${u}${u.includes("?") ? "&" : "?"}v=${v}` : u);
  return (
    <Helmet>
      {s.favicon_url && <link rel="icon" href={bust(s.favicon_url)} />}
      {s.favicon_url && <link rel="shortcut icon" href={bust(s.favicon_url)} />}
      {s.apple_touch_icon_url && <link rel="apple-touch-icon" href={bust(s.apple_touch_icon_url)} />}
      {s.icon_192_url && <link rel="icon" type="image/png" sizes="192x192" href={bust(s.icon_192_url)} />}
      {s.icon_512_url && <link rel="icon" type="image/png" sizes="512x512" href={bust(s.icon_512_url)} />}
      {s.social_share_image_url && <meta property="og:image" content={s.social_share_image_url} />}
    </Helmet>
  );
}
